import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './HomePageGoogle.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import AllServicesData from '../ServicesPage/AreaData'
import LocationReviewsData from './LocationReviewsData'
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';

export default function HomePageGoogle({ CitiePhone, locationsMain, CitiesData }) {
    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);
    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [

            {
                "title": "Why Choose Master Air Duct?",
                "content": "With years of experience, we provide professional, reliable air duct cleaning services, ensuring cleaner, healthier air in every space."
            },
            {
                "title": "What Services Do You Offer?",
                "content": "We offer residential and commercial air duct cleaning, dryer vent cleaning, inspections, repairs, and maintenance for optimal air quality."
            },
            {
                "title": "How Much Is Air Duct Inspection?",
                "content": "Our air duct inspection is free, helping to identify any issues before recommending further action."
            },
            {
                "title": "Can You Clean and Repair at the Same Time?",
                "content": "Yes, we offer same-day cleaning and repairs during your appointment if needed."
            },
            {
                title: `Do you provide services surrounding ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}?`,
                content: `Yes, we don't just serve ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}! We cover a wide area, including a 75-mile radius around ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}. Whether you're in nearby towns or surrounding areas, we're here to help.`
            },
            {
                "title": "How Do I Book an Appointment?",
                "content": `Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or fill out the <a href='/book${location.search}'>online form</a> to schedule your service.`
            }
        ]
    };
    const styles = {
        bgColor: '#f9f1e5',
        titleTextColor: 'white',
        titleTextSize: '18px',
        rowTitleColor: '#0f2d4f',
        rowTitleTextSize: '21px',
        rowContentColor: '#242424',
        rowContentTextSize: '16px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "#0f2d4f",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "Master Air Duct" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and Master Air Duct from title)(if no keywords just do for chimney sweep) and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()
                // console.log(dataChat)
                // console.log(dataChat.content)
                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }
        })();
    }, []);
    return (
        <div className="HomePageGoogle" id="homepage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>Master Air Duct Cleaning | Expert Air Duct Cleaning, Inspection & Services | {CitiePhone}</title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content="Air Duct Cleaning | Expert Air Duct Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Air Duct Cleaning | Expert Air Duct Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.masterairducts.com/" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content="Air Duct Cleaning provides top-quality Air Duct cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your Air Duct service needs." data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content="Air Duct Cleaning provides top-quality Air Duct cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your Air Duct service needs." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Air Duct Cleaning" data-react-helmet="true" />
                <meta name="keywords" content="Air Duct Cleaning, Air Duct Inspection, Air Duct Inspection, Fireplace Inspection, Fireplace Cleaning, Air Duct Cleaning, Air Duct Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Air Duct Inspection, Fireplace Inspection, Fireplace Cleaning, Air Duct Cleaning, Air Duct Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Air Duct services, Air Duct service, Air Duct Inspection, Fireplace Inspection, Fireplace Cleaning, Air Duct Cleaning, Air Duct Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Air Duct Insulation, Air Duct Installation, Air Duct Liner Repair, Air Duct Pointing, Air Duct Rainp Installation, Air Duct Repair, Air Duct Crown Repair, Air Duct Restoration, Air Duct Flue Installation, Air Duct Flue Repair, ​Air Duct Construction, Air Duct Vent Installation, Air Duct Flashing, Flexible Air Duct Liner Installation, Air Duct Damper Repair, Chimneyp Repair, Fireplace Insulation, Fireplace Installation, Fireplace Liner Repair, Fireplace Pointing, Fireplace Rainp Installation, Fireplace Repair, Fireplace Crown Repair, Fireplace Restoration, Fireplace Flue Installation, Fireplace Flue Repair, Ffireplace Construction, Fireplace Vent Installation, Fireplace Flashing, Flexible fireplace Liner Installation, Fireplace Damper Repair, Fireplacep" data-react-helmet="true" />
            </Helmet>
            {/* MainBanner */}
            <div className="MainBanner">
                <div className="MainBannerLeft">
                    <div className="MainBannerLeftLeft">
                        <img src={require(`../../ImagesLogos/Logo1.png`)} />

                    </div>
                    <div className="MainBannerLeftRight">
                        <h1>OUR FAMILY</h1>
                        <h4>SERVING  YOURS!</h4>
                        <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • Air Duct & Dryer Vent Cleaning, Repair, Maintenance Near You</h2>
                        {/* <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Air Duct & Dryer Vent Cleaning, Repair, Maintenance Near You</h2> */}
                        <h3><img src={require(`../../Images/quality.png`)} alt="Locally Owned & Operated Master Air Duct Cleaning Repair" />Locally Owned & Operated</h3>
                        <h3><img src={require(`../../Images/quality.png`)} alt="Licensed | Bonded | Insured Master Air Duct Cleaning Repair" />Licensed, Bonded, Insured!</h3>
                        <h3><img src={require(`../../Images/quality.png`)} alt="Satisfaction Guaranteed Master Air Duct Cleaning Repair" />Satisfaction Guaranteed</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!</a>
                            <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                            <a onClick={() => navigate(`/book${location.search}`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me Master Air Duct" /></a>
                        </div>
                        <div className="MainBannerLeftImages">
                            <img src={require(`../../Images/YELP.png`)} alt="Master Air Duct Cleaning Cleaning Yelp Review" />
                            <img src={require(`../../Images/Angie.png`)} alt="Master Air Duct Cleaning Cleaning Angie Review" />
                            <img src={require(`../../Images/HomeAdvisor.png`)} alt="Master Air Duct Cleaning Cleaning HomeAdvisor Review" />
                            <img src={require(`../../Images/BBB.png`)} alt="Master Air Duct Cleaning Cleaning BBB Review" />
                            <img src={require(`../../Images/Google.png`)} alt="Master Air Duct Cleaning Cleaning Google Review" />
                            <img src={require(`../../Images/Porch.png`)} alt="Master Air Duct Cleaning Cleaning Porch Review" />
                        </div>

                    </div>

                </div>
            </div>
            {/* BookAnAppointmentMainComponentEmergery */}
            <div className="BookAnAppointmentMainComponentEmergery1" >
                <div className="BookAnAppointmentMainComponentEmergeryBox">
                    <div className="MainBannerLeftRated">
                        <p>Fresh Air, Cleaner Home. Call Master Air Duct!</p>

                        <h3>Rated 4.9 on Google</h3>
                        <span>
                            <h4>4.9</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                    {/* <a href={`tel:${CitiePhone}`}> Click To Call: {CitiePhone}</a> */}
                    <img src={require(`../../ImagesLogos/Image1Logo.png`)} />
                </div>
            </div>
            <div className="MainBanner2TopBoxMainChat">
                <img src={require(`../../ImagesLogos/Banner1Logo.png`)} />
                <div className="MainBanner2TopBoxMainChatText">
                    <h4>{response.title}</h4>
                    <h3>{response.body}</h3>
                    <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                </div>
            </div>
            {/* MainBanner2Top2 */}
            <div className="MainBanner2Top2" id="ourservices">
                <div className="MainBanner2TopBoxMenuShadow1"></div>
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/PhotoImg1.jpg`)} alt="Air Duct Cleaning" />
                        <h3>Air Duct Cleaning</h3>
                        <h2>Experience cleaner, fresher air with our thorough air duct cleaning services, ensuring a healthier home environment.</h2>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/PhotoImg4.jpg`)} alt="Air Duct Cleaning" />
                        <h3>Dryer Vent Cleaning</h3>
                        <h2>Prevent fire hazards and improve dryer efficiency with our professional dryer vent cleaning services for safer homes.</h2>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/PhotoImg5.png`)} alt="Air Duct Cleaning" />
                        <h3>Air Duct & Dryer Vent Repair</h3>
                        <h2>Our expert air duct repairs restore efficiency and performance, eliminating leaks for better air quality and energy savings.</h2>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/PhotoImg2.jpg`)} alt="Air Duct Cleaning" />
                        <h3>Air Duct & Dryer Vent Inspection</h3>
                        <h2>Our detailed air duct inspections identify issues early, ensuring optimal system performance and indoor air quality.</h2>
                    </a>
                </div>
                <div className="MainBanner2TopBoxMenuShadow2"></div>
            </div>

            {/* All home service categories — sub-categories grid */}
            {!location.pathname.startsWith("/local") && (<div className="CategoryBlocks CategoryBlocks-Hide-On-Local">
                {[
                    { key: "airduct", label: "Air Duct", href: "/airduct", match: (a) => /air duct|hvac duct|air vent|coil cleaning|mold removal from air|uv air|anti-microbial duct|indoor air quality|furnace cleaning/i.test(a.Title) },
                    { key: "chimney", label: "Chimney & Fireplace", href: "/chimney", match: (a) => /chimney|fireplace|creosote|smoke chamber|masonry|tuckpoint|wood stove|gas fireplace|pellet stove|insert/i.test(a.Title) },
                    { key: "dryer", label: "Dryer Vent", href: "/service/Dryer-Vent-Cleaning", match: (a) => /dryer|lint|bird guard/i.test(a.Title) },
                ].map((cat) => {
                    const subs = AllServicesData.filter(cat.match).slice(0, 8);
                    if (subs.length === 0) return null;
                    return (
                        <div key={cat.key} className={`CategoryBlock CategoryBlock-${cat.key}`}>
                            <div className="CategoryBlockHeader">
                                <h2>{cat.label}</h2>
                                <a href={cat.href}>View {cat.label} →</a>
                            </div>
                            <div className="CategoryBlockGrid">
                                {subs.map((s, i) => (
                                    <a key={i} href={s.Path} className="CategoryBlockItem">
                                        <h3>{s.Title}</h3>
                                        <p>{s.Full}</p>
                                        <span>Learn more →</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>)}

            {/* <div className="HomePageGoogleCoupon" id="off"> */}
            <div className="HomePageGoogleCoupon" id="off">
                <div className="HomePageGoogleCouponTop">
                    <div className="HomePageGoogleCouponText">
                        <h1>Get a Complimentary Estimate</h1>
                        {/* <h1>Get a Complimentary Estimate & Save 10% on All Services!</h1> */}
                        <h2>At Master Air Duct, we believe in delivering top-notch service at a great value. That’s why we offer free estimates for all our services. Whether it’s residential air duct cleaning, commercial duct maintenance dryer vent cleaning, or any repairs you can count on us to provide clear, honest pricing before we start.</h2>
                        <h3>Contact us today to schedule your free estimate and take advantage of this limited-time offer! <a href={`/book${location.search}`}>Online appointments available</a></h3>
                    </div>
                    <div className="HomePageGoogleCouponMain" style={{ "display": "none" }}>
                        <div className="coupon">
                            <div class="left">
                                <div><h3>Enjoy Your Gift</h3></div>
                            </div>
                            <div class="center">
                                <div>
                                    <h2>10% OFF</h2>
                                    <h3>Coupon</h3>
                                    <small>ALL SERVICES</small>
                                </div>
                            </div>
                            <div class="right">
                                <div>MASTER</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {/* HomePageGoogleReviews */}
            <div className="HomePageGoogleReviews" id="reviews">
                <h1>Trusted by Our Community</h1>
                <div className="HomePageGoogleReviewsList">
                    {LocationReviewsData.map((A, index) =>
                        <div key={index} className="HomePageGoogleReviewsBox">
                            <h1>
                                <img src={require(`../../Images/checklist2.png`)} />
                                <img src={require(`../../Images/GoogleIcons.png`)} />
                            </h1>
                            <h3>{A.review}</h3>
                            <div className="HomePageGoogleReviewsBoxMore">
                                <img src={require(`../../Images/people.png`)} />
                                <span>
                                    <h2>{A.customer}</h2>
                                    <h4>
                                        <img src={require(`../../Images/stars.png`)} />
                                        <img src={require(`../../Images/stars.png`)} />
                                        <img src={require(`../../Images/stars.png`)} />
                                        <img src={require(`../../Images/stars.png`)} />
                                        <img src={require(`../../Images/stars.png`)} />
                                    </h4>
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* MainBanner2 */}
            <div className="MainBanner2" id="about">
                <div className="MainBanner2Left">
                    <div className="MainBanner2TopTopRight">
                        <h4>MASTER YOUR DUCTS WITH MASTER AIR DUCT!</h4>
                        <h5>It’s more than a service—it’s a commitment to your comfort and safety.</h5>
                        <div className="MainBanner2TopBox">
                            <h2>TRUSTED EXPERTISE</h2>
                            <h3>Since 2001, Master Air Duct has set the standard for air duct services in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> with a reputation built on excellence and years of expertise.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>CLEAR & HONEST PRICING</h2>
                            <h3>No surprises, no gimmicks—just transparent pricing that covers all air duct services, even on holidays.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>FAST & RELIABLE SERVICE</h2>
                            <h3>Need urgent help? We offer same-day and emergency air duct services, 365 days a year, to keep your home fresh and safe.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>TOP-TIER QUALITY</h2>
                            <h3>From thorough cleaning to reliable repairs, our team uses advanced techniques and state-of-the-art tools for a job done right every time.</h3>
                        </div>
                    </div>

                    {/* Title */}
                    <div className="MainBanner2TopTopBtn">
                        <a href={`tel:${CitiePhone}`}>CALL NOW {CitiePhone}</a>
                        <a onClick={() => navigate(`/book${location.search}`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning Master| Air Duct Repair Master| Air Duct Services Master| Air Duct Inspection Master" /></a>
                    </div>
                </div>
                <div className="MainBanner2RightRgt">
                    <img src={require(`../../ImagesLogos/Image2Logo.png`)} />

                </div>
            </div>
            {/* HomePageGoogleBefore */}
            <div className="HomePageGoogleBefore">
                <h1>Quality Air Duct Cleaning Services</h1>
                <h2>We’re proud to provide community members with the best Air Duct Cleaning and Dryer Vent Cleaning service in the industry. </h2>
                <div className="HomePageGoogleBeforeImages">
                    <img src={require(`../../Images/Before1.jpeg`)} />
                    <img src={require(`../../Images/Before2.jpeg`)} />
                    <img src={require(`../../Images/Before3.jpeg`)} />
                    <img src={require(`../../Images/Before4.jpeg`)} />
                    <img src={require(`../../Images/Before5.jpeg`)} />
                </div>
            </div>
            {/* BookAnAppointment */}
            <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            {/* HomePageGoogleServices */}
            <div className="HomePageGoogleServices">
                <div className="MainBanner2TopBoxMenuShadow1">
                    <h3>OUR SERVICES</h3>
                </div>
                <div className="HomePageGoogleServicesMain">
                    <div className="HomePageGoogleServicesBox">
                        <div className="HomePageGoogleServicesBoxLeft">
                            <img src={require(`../../Images/PhotoImg1.jpg`)} alt="Air Duct Cleaning" />
                        </div>
                        <div className="HomePageGoogleServicesBoxRight">
                            <h1>Air Duct Cleaning</h1>
                            <h2>Improve your home's air quality with our expert air duct cleaning services! Master Air Duct uses state-of-the-art equipment to remove dust, allergens, and debris, ensuring cleaner, fresher air. Our professional team ensures every duct is thoroughly cleaned, giving you peace of mind and better air flow.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <div className="HomePageGoogleServicesBoxLeft">
                            <img src={require(`../../Images/PhotoImg4.jpg`)} alt="Air Duct Cleaning" />
                        </div>
                        <div className="HomePageGoogleServicesBoxRight">
                            <h1>Dryer Vent Cleaning</h1>
                            <h2>Protect your home from fire hazards with Master Air Duct's dryer vent cleaning! Our thorough service removes lint and debris buildup, improving dryer efficiency and reducing energy costs. Trust our experienced team to keep your home safe while ensuring faster, more efficient drying.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <div className="HomePageGoogleServicesBoxLeft">
                            <img src={require(`../../Images/PhotoImg5.png`)} alt="Air Duct Cleaning" />
                        </div>
                        <div className="HomePageGoogleServicesBoxRight">
                            <h1>Air Duct & Dryer Vent Repair</h1>
                            <h2>Need fast, reliable air duct or dryer repairs? Master Air Duct has you covered! Our skilled technicians can fix leaks, breaks, and damages that affect airflow and dryer performance. Improve energy efficiency, safety, and comfort with our prompt, professional repair services today.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <div className="HomePageGoogleServicesBoxLeft">
                            <img src={require(`../../Images/PhotoImg2.jpg`)} alt="Air Duct Cleaning" />
                        </div>
                        <div className="HomePageGoogleServicesBoxRight">
                            <h1>Air Duct & Dryer Vent Inspection</h1>
                            <h2>Stay proactive with air duct and dryer inspections from Master Air Duct! Our thorough inspection service identifies blockages, leaks, or potential hazards. Regular inspections enhance your home’s safety, extend system life, and boost efficiency—keeping your air ducts and dryer in top shape.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <div className="HomePageGoogleServicesBoxLeft">
                            <img src={require(`../../Images/PhotoImg7.png`)} alt="Air Duct Cleaning" />
                        </div>
                        <div className="HomePageGoogleServicesBoxRight">
                            <h1>Air Duct Sanitation Services</h1>
                            <h2>Ensure clean, healthy air in your home with expert air duct sanitation. Our services eliminate bacteria, allergens, and odors, improving indoor air quality and efficiency. Breathe easier with sanitized air ducts—your health and comfort are our priority!</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleServicesBox">
                        <div className="HomePageGoogleServicesBoxLeft">
                            <img src={require(`../../Images/PhotoImg8.png`)} alt="Air Duct Cleaning" />
                        </div>
                        <div className="HomePageGoogleServicesBoxRight">
                            <h1>UV Light Installation for Cleaner Air</h1>
                            <h2>Upgrade your HVAC system with UV light installation. UV lights kill bacteria, mold, and viruses, enhancing air quality and system efficiency. Protect your family’s health with this powerful solution for fresher, cleaner indoor air.</h2>
                        </div>
                    </div>
                </div>
                <div className="MainBanner2TopBoxMenuShadow2"></div>
            </div>
            {locationsMain.find(a => a.Phone == CitiePhone) ?
                <div className="HomePageGoogleLocation">
                    <div className="HomePageGoogleLocationBox">

                        <div className="HomePageGoogleLocationLeft">
                            <h1>Our Service Area / Locations</h1>
                            <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "Your Area"}</b> And Surrounding Areas</h2>
                            <h3>75-Radius Arround {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h3>
                            {locationsMain.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                                <div key={index} className="HomePageGoogleLocationLeftBox">
                                    <h4>{A.Location1}</h4>
                                    <h5>{A.Address1}</h5>
                                    <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                                </div>
                            )}
                        </div>
                        <div className="HomePageGoogleLocationRight">
                            <div className="HomePageGoogleLocationRightBorder"></div>
                            <iframe src={locationsMain.find(a => a.Phone == CitiePhone).Map} ></iframe>
                        </div>
                    </div>

                </div>
                : null}
            {/* MainBanner6 */}
            <div className="MainBanner6" id="contact">
                <div className="MainBanner6Left">
                    <h2>NEED HELP? WE’RE HERE FOR YOU!</h2>
                    <h3>Reach Out to Us Anytime – We're Available 24/7 by Phone for the Fastest Response and a Complimentary Consultation.</h3>
                    <a className="MainBanner6LeftContact" href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                    <div className="MainBanner4FaqMore">
                        <Faq
                            data={data}
                            styles={styles}
                            config={config}
                        />
                    </div>
                </div>
                <div className="MainBanner6Right">
                    <img src={require(`../../ImagesLogos/Logo1.png`)} />
                </div>
            </div>

        </div >
    )
}

